import React, { useEffect } from 'react';
import logo from './img/logo_new.png';
import './css/footer.css';
import { useLanguage } from './contexts/LanguageContext';
import LanguageSelector from './components/LanguageSelector';

const PrivacyPolicy = ({ onBack, onShowDonate }) => {
  const { t } = useLanguage();

  return (
    <div>
      <div>
    <div className="privacy-policy-container">
      <div className="logocontent">
      <img className="logo" src={logo} alt="Logo" />
      </div>
      
      <div className="privacy-content">
        <div>
        <h1>{t('privacyPolicy.title')}</h1>
        <p className="last-updated">{t('privacyPolicy.lastUpdated')}</p>
        
        <p>{t('privacyPolicy.intro')}</p>

        <section>
          <h2>{t('privacyPolicy.sections.informationWeCollect.title')}</h2>
          <p>{t('privacyPolicy.sections.informationWeCollect.intro')}</p>
          <ul>
            <li><strong>{t('privacyPolicy.sections.informationWeCollect.donations')}</strong></li>
            <li><strong>{t('privacyPolicy.sections.informationWeCollect.contactForm')}</strong></li>
          </ul>
        </section>

        <section>
          <h2>{t('privacyPolicy.sections.cookies.title')}</h2>
          <p>{t('privacyPolicy.sections.cookies.intro')}</p>
          <ul>
            <li>{t('privacyPolicy.sections.cookies.paypalCookies')}</li>
            <li>{t('privacyPolicy.sections.cookies.sessionCookies')}</li>
          </ul>
          <p>{t('privacyPolicy.sections.cookies.browserSettings')}</p>
        </section>

        <section>
          <h2>{t('privacyPolicy.sections.howWeUse.title')}</h2>
          <p>{t('privacyPolicy.sections.howWeUse.intro')}</p>
          <ul>
            <li>{t('privacyPolicy.sections.howWeUse.processDonations')}</li>
            <li>{t('privacyPolicy.sections.howWeUse.respondInquiries')}</li>
            <li>{t('privacyPolicy.sections.howWeUse.keepRecords')}</li>
          </ul>
          <p>{t('privacyPolicy.sections.howWeUse.noSharing')}</p>
        </section>

        <section>
          <h2>{t('privacyPolicy.sections.dataSecurity.title')}</h2>
          <p>{t('privacyPolicy.sections.dataSecurity.content')}</p>
        </section>

        <section>
          <h2>{t('privacyPolicy.sections.yourRights.title')}</h2>
          <p>{t('privacyPolicy.sections.yourRights.intro')}</p>
          <ul>
            <li>{t('privacyPolicy.sections.yourRights.access')}</li>
            <li>{t('privacyPolicy.sections.yourRights.correction')}</li>
            <li>{t('privacyPolicy.sections.yourRights.withdraw')}</li>
          </ul>
          <p>{t('privacyPolicy.sections.yourRights.contact')}</p>
        </section>

        <section>
          <h2>{t('privacyPolicy.sections.contactUs.title')}</h2>
          <p>{t('privacyPolicy.sections.contactUs.intro')}</p>
          <ul>
            <li>{t('privacyPolicy.sections.contactUs.email')}</li>
            <li>{t('privacyPolicy.sections.contactUs.address')}</li>
          </ul>
        </section>
        </div>
      </div>
      </div>
      </div>
      <div className="fixed-buttons-container">
        <button className="privacy-donate-button" onClick={onShowDonate}>
          {t('privacyPolicy.donate')}
        </button>
        <LanguageSelector />
      </div>
      
      <button className="privacy-back-button" onClick={onBack}>
        {t('privacyPolicy.backToMain')}
      </button>
      </div>
  );
};

export default PrivacyPolicy;
